"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenShareButton = void 0;
// (C) 2021 GoodData Corporation
/**
 * This implementation of share button keeps it out of sight and effectively disables it.
 *
 * @alpha
 */
exports.HiddenShareButton = function () {
    return null;
};
//# sourceMappingURL=HiddenShareButton.js.map